import React from 'react';

export default function MembersIcon() {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.6663 6.66671V10.6667M14.6663 6.66671L7.99967 3.33337L1.33301 6.66671L7.99967 10L14.6663 6.66671ZM3.99967 8.00004V11.3334C5.99967 13.3334 9.99967 13.3334 11.9997 11.3334V8.00004'
        stroke='url(#paint0_linear_1658_900)'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1658_900'
          x1='1.22999'
          y1='1.38144'
          x2='7.05441'
          y2='13.3634'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0.65' />
        </linearGradient>
      </defs>
    </svg>
  );
}
